import type {ReactNode} from 'react';

import {Heading} from '@/modules/foundation/components/typography/heading';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = {
	children: ReactNode;
	className?: string;
	id?: string;
};

export const Heading2 = ({children, className, id}: Props) => {
	return (
		<Heading
			{...(id ? {id} : {})}
			level={2}
			size="lg"
			spacing
			className={cn(['scroll-m-14', className])}
		>
			{children}
		</Heading>
	);
};

export const Heading3 = ({children, className}: Props) => {
	return (
		<Heading
			level={3}
			size="md"
			spacing
			className={cn(['scroll-m-14', className])}
		>
			{children}
		</Heading>
	);
};

export const Heading4 = ({children, className}: Props) => {
	return (
		<Heading
			level={4}
			size="sm"
			spacing
			className={cn(['scroll-m-14', className])}
		>
			{children}
		</Heading>
	);
};

export const Heading5 = ({children, className}: Props) => {
	return (
		<Heading
			level={5}
			size="lg"
			spacing
			className={cn(['scroll-m-14', className])}
		>
			{children}
		</Heading>
	);
};

export const Heading6 = ({children, className}: Props) => {
	return (
		<Heading
			level={6}
			size="md"
			spacing
			className={cn(['scroll-m-14', className])}
		>
			{children}
		</Heading>
	);
};
